import { Collapse } from 'antd';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function O() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('powerindependence');
    const { locale } = useRouter();
    const FAQ_MAP: any = {
        fr: [
            {
                title: t('secO_q1'),
                desc: t('secO_a1'),
            },
            {
                title: t('secO_q2'),
                desc: t('secO_a2'),
            },
            {
                title: t('secO_q3'),
                desc: t('secO_a3'),
            },
            {
                title: t('secO_q4'),
                desc: t('secO_a4'),
            },
            {
                title: t('secO_q5'),
                desc: t('secO_a5'),
            },
        ],
        de: [
            {
                title: t('secO_q4'),
                desc: t('secO_a4'),
            },
            {
                title: t('secO_q7'),
                desc: t('secO_a7'),
            },
            {
                title: t('secO_q5'),
                desc: t('secO_a5'),
            },
            {
                title: t('secO_q1'),
                desc: t('secO_a1'),
            },
            {
                title: t('secO_q2'),
                desc: t('secO_a2'),
            },
            {
                title: t('secO_q3'),
                desc: t('secO_a3'),
            },
            {
                title: t('secO_q6'),
                desc: t('secO_a6'),
            },
        ],
        eu: [
            {
                title: t('secO_q1'),
                desc: t('secO_a1'),
            },
            {
                title: t('secO_q2'),
                desc: t('secO_a2'),
            },
            {
                title: t('secO_q3'),
                desc: t('secO_a3'),
            },
            {
                title: t('secO_q4'),
                desc: t('secO_a4'),
            },
            {
                title: t('secO_q5'),
                desc: t('secO_a5'),
            },
            {
                title: t('secO_q6'),
                desc: t('secO_a6'),
            },
        ],
        uk: [
            {
                title: t('secO_q1'),
                desc: t('secO_a1'),
            },
            {
                title: t('secO_q2'),
                desc: t('secO_a2'),
            },
            {
                title: t('secO_q3'),
                desc: t('secO_a3'),
            },
            {
                title: t('secO_q4'),
                desc: t('secO_a4'),
            },
            {
                title: t('secO_q5'),
                desc: t('secO_a5'),
            },
            {
                title: t('secO_q6'),
                desc: t('secO_a6'),
            },
        ],
        it: [
            {
                title: t('secO_q1'),
                desc: t('secO_a1'),
            },
            {
                title: t('secO_q2'),
                desc: t('secO_a2'),
            },
            {
                title: t('secO_q3'),
                desc: t('secO_a3'),
            },
            {
                title: t('secO_q4'),
                desc: t('secO_a4'),
            },
            {
                title: t('secO_q5'),
                desc: t('secO_a5'),
            },
            {
                title: t('secO_q6'),
                desc: t('secO_a6'),
            },
        ],
        es: [
            {
                title: t('secO_q1'),
                desc: t('secO_a1'),
            },
            {
                title: t('secO_q2'),
                desc: t('secO_a2'),
            },
            {
                title: t('secO_q3'),
                desc: t('secO_a3'),
            },
            {
                title: t('secO_q4'),
                desc: t('secO_a4'),
            },
            {
                title: t('secO_q5'),
                desc: t('secO_a5'),
            },
            {
                title: t('secO_q6'),
                desc: t('secO_a6'),
            },
        ],
    };
    const lists: any = FAQ_MAP[locale];

    return (
        <div id="power-independence-O" className={`power-independence-O ${css['power-independence-O']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <p className="title">{t('secO_title')}</p>
                </div>
                <Collapse
                    ghost={true}
                    className="collapse-lists"
                    defaultActiveKey={0}
                    expandIcon={({ isActive }: any) => (
                        <svg
                            className={`collapse-icon ${isActive ? 'active' : ''}`}
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                        >
                            <path d="M17.5 15L12.5 10L7.5 15" stroke="#000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    )}
                    expandIconPosition="right"
                >
                    {lists?.map((list: any, k: number) => (
                        <Collapse.Panel className="list-title" key={k} header={list.title}>
                            <p className="list-desc">{list.desc}</p>
                        </Collapse.Panel>
                    ))}
                </Collapse>
            </div>
        </div>
    );
}
